import { getFormatMessage } from '@/utils/utils'
import { SearchOutlined } from '@ant-design/icons'
import { Row, Col, Space, Button, Input, Form, Dropdown, Menu } from 'antd'
import React, { useEffect } from 'react'
import { TemplateSearchItem, TemplateToolbarProps } from '../interface'

export const TemplateToolbar: React.FC<TemplateToolbarProps> = (
  props: TemplateToolbarProps
) => {
  const { searchItem, selectable, onMenuItemClick } = props
  const [form] = Form.useForm<TemplateSearchItem>()
  const formatMessage = getFormatMessage()

  const isHide =
    props.showImport === false &&
    props.showCreate === false &&
    props.showBatch === false
      ? true
      : false

  const menu = (
    <Menu>
      <Menu.Item
        key='contextmenu.delete'
        onClick={() => onMenuItemClick?.('delete')}
      >
        {formatMessage({ id: 'app.template.toolbar.batch.delete' })}
      </Menu.Item>
      <Menu.Item
        key='contextmenu.export'
        onClick={() => onMenuItemClick?.('export')}
      >
        {formatMessage({ id: 'app.template.toolbar.batch.export' })}
      </Menu.Item>
    </Menu>
  )

  const handleClean = () => {
    form.resetFields()
    if (props.onSearch) {
      props.onSearch({})
    }
  }

  const handleSearch = () => {
    if (props.onSearch) {
      const search = form.getFieldsValue()
      props.onSearch(search)
    }
  }

  useEffect(() => {
    if (searchItem === undefined) {
      form.resetFields()
    }
  }, [searchItem])

  return (
    <div>
      <Row style={{ marginBottom: 16 }}>
        <Col span={isHide ? 24 : 18}>
          <Form form={form} layout='inline'>
            {(props.showName == undefined ? true : props.showName) && (
              <Form.Item name='name'>
                <Input
                  placeholder={formatMessage({
                    id: 'app.template.toolbar.name.placeholder'
                  })}
                  allowClear={true}
                />
              </Form.Item>
            )}

            {(props.showRemark == undefined ? true : props.showRemark) && (
              <Form.Item name='remark'>
                <Input
                  placeholder={formatMessage({
                    id: 'app.template.toolbar.remark.placeholder'
                  })}
                  allowClear={true}
                />
              </Form.Item>
            )}

            {(props.showClean == undefined ? true : props.showClean) && (
              <Form.Item>
                <Button type='link' onClick={handleClean}>
                  {formatMessage({ id: 'app.template.toolbar.clean' })}
                </Button>
              </Form.Item>
            )}

            {(props.showSearch == undefined ? true : props.showSearch) && (
              <Form.Item>
                <Button
                  type='primary'
                  icon={<SearchOutlined />}
                  onClick={handleSearch}
                >
                  {formatMessage({ id: 'app.template.toolbar.search' })}
                </Button>
              </Form.Item>
            )}
          </Form>
        </Col>

        {!isHide && (
          <Col span={6}>
            <Space align='end'>
              {(props.showImport == undefined ? true : props.showImport) && (
                <Button type='primary' onClick={props.onImport}>
                  {formatMessage({ id: 'app.template.toolbar.import' })}
                </Button>
              )}

              {(props.showCreate == undefined ? true : props.showCreate) && (
                <Button type='primary' onClick={props.onCreate}>
                  {formatMessage({ id: 'app.template.toolbar.create' })}
                </Button>
              )}

              {(props.showBatch == undefined ? true : props.showBatch) && (
                <Dropdown disabled={!selectable} overlay={menu}>
                  <Button type='primary'>
                    {formatMessage({ id: 'app.template.toolbar.batch' })}
                  </Button>
                </Dropdown>
              )}
            </Space>
          </Col>
        )}
      </Row>
    </div>
  )
}
